const handleLogout = () => {
  window.location.href = "/login";
  window.location.reload();
};
export default handleLogout;
